module.exports = __webpack_public_path__ + "static/img/14000586.764336dc.png";